module.exports = __webpack_public_path__ + "static/media/progress-reading-streak.32758dea.svg";